import React from 'react';

export type ContentManagementSection = 'articles' | 'prompts' | 'supporting-data' | 'inventory' | 'performance' | 'health' | 'editorial-memory';

const SECTIONS: { id: ContentManagementSection; label: string; icon: string }[] = [
  { id: 'articles', label: 'Article Generation', icon: '📝' },
  { id: 'prompts', label: 'Prompts', icon: '💬' },
  { id: 'supporting-data', label: 'Supporting Data', icon: '📋' },
  { id: 'inventory', label: 'Content Inventory', icon: '📚' },
  { id: 'performance', label: 'Performance', icon: '📊' },
  { id: 'editorial-memory', label: 'Editorial Memory', icon: '🧠' },
  { id: 'health', label: 'Health Checks', icon: '🩺' },
];

export function ContentManagementNav({
  selectedSection,
  onSelectSection,
  onBack,
  onCollapse,
}: {
  selectedSection: ContentManagementSection;
  onSelectSection: (section: ContentManagementSection) => void;
  onBack: () => void;
  onCollapse?: () => void;
}) {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <button
            onClick={onBack}
            className="p-1 hover:bg-gray-100 rounded-md focus:outline-none"
            title="Back to projects"
          >
            <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wider">
            Content Management
          </h2>
        </div>
        {onCollapse && (
          <button
            onClick={onCollapse}
            className="p-1 hover:bg-gray-100 rounded-md focus:outline-none"
            title="Collapse sidebar"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
      </div>
      <nav className="space-y-1">
        {SECTIONS.map((section) => (
          <button
            key={section.id}
            onClick={() => onSelectSection(section.id)}
            className={`w-full flex items-center px-3 py-2 text-sm rounded-md
              ${selectedSection === section.id
                ? 'bg-blue-50 text-blue-700'
                : 'text-gray-700 hover:bg-gray-50'}`}
          >
            <span className="mr-3">{section.icon}</span>
            {section.label}
          </button>
        ))}
      </nav>
    </>
  );
}
